import React from 'react';
import { Table, Input, Card } from 'antd';
const EarningsList = ({ setDataSource, dataSource, t, form }) => {
  const columns = [
    {
      title: t.salary_component,
      dataIndex: 'salary_component',
      render: (text, record, index) => (
        <Input
          disabled
          placeholder={t.salary_component}
          style={{ width: '100%' }}
          value={record.salary_component}
        />
      ),
    },
    {
      title: t.abbr,
      dataIndex: 'abbr',
      render: (text, record, index) => (
        <Input
          disabled
          placeholder={t.abbr}
          style={{ width: '100%' }}
          value={record.abbr}
        />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount',
      render: (text, record, index) => (
        <Input
          disabled
          placeholder={t.amount}
          style={{ width: '100%' }}
          value={record.amount}
        />
      ),
    },
    {
      title: t.year_to_date,
      dataIndex: 'year_to_date',
      render: (text, record, index) => (
        <Input
          disabled
          placeholder={t.year_to_date}
          style={{ width: '100%' }}
          value={record.year_to_date}
        />
      ),
    },
  ];
  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
    </Card>
  );
};

export default EarningsList;
